import { Chip } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import React from 'react';

interface FancyTagProps {
  text: string;
  size?: 'small' | 'medium';
  colorVariant?: Record<number, string>;
  onDelete?: () => void;
  startIcon?: React.ReactNode;
}


const FancyTag = ({ text, colorVariant = colors.blue, onDelete, startIcon, size = 'medium' }: FancyTagProps) => {
  const backgroundColor = colorVariant[100];
  const textColor = colorVariant[500];

  return (
    <Chip
      label={text}
      size={size}
      onDelete={onDelete}
      deleteIcon={
        onDelete ? (
          <Close size="small" color={textColor} />
        ) : undefined
      }
      icon={startIcon ? React.cloneElement(startIcon as React.ReactElement, { color: textColor, size: 16 }) : undefined}
      sx={{
        backgroundColor,
        border: `1px solid ${textColor}`,
        borderRadius: '8px',
        minHeight: '32px',
        color: textColor,
        fontWeight: 400,
        '&.MuiChip-root': {
          padding: '0 8px', // need to override it using class specificity 
        },
        '& .MuiChip-icon': {
          color: textColor,
          marginLeft: '8px',
          marginRight: '-4px',
        },
        '& .MuiChip-deleteIcon': {
          color: textColor,
          '&:hover': {
            color: textColor,
            opacity: 0.7,
          },
        },
      }}
    />
  );
};

export default FancyTag;
